"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const data_table_1 = tslib_1.__importDefault(require("../../../../../layouts/data-table"));
const react_redux_1 = require("react-redux");
const actions_1 = require("../../../../actions/actions");
const api_1 = require("src/app/auto-ml/utils/api");
const js_cookie_1 = tslib_1.__importDefault(require("js-cookie"));
function PreProcessingStep1(props) {
    const { projectInfo } = props;
    const dispatch = react_redux_1.useDispatch();
    const [csvData, setCsvData] = react_1.useState(null);
    react_1.useEffect(() => {
        let isMounted = true;
        const getCsvFile = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = {
                projectname: projectInfo.projectname,
                problemtype: projectInfo.problemtype,
                version_name: projectInfo.version_name,
                userid: js_cookie_1.default.get('USER_ID')
            };
            const firstCsv = yield api_1.getFirstCSV(data);
            if (firstCsv.data.data) {
                setCsvData(firstCsv.data.data);
            }
            else {
                dispatch(actions_1.changeMainStep(1));
            }
        });
        getCsvFile();
        return () => {
            isMounted = false; // Cleanup on unmount
        };
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(data_table_1.default, { csvData: csvData })));
}
exports.PreProcessingStep1 = PreProcessingStep1;
//# sourceMappingURL=pre-processing-step1.js.map